<template lang='pug'>
  div(:id='id' v-resize='debouncedResize' ref='chart' :style='{width, height}')
</template>

<script>
import {debounce} from 'lodash';
import echarts from 'echarts';

export default {
  name: 'BionicMetricsChart',
  components: {},
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '500px'
    },
    options: {
      type: Object,
      required: true
    }
  },
  created() {
    this.debouncedResize = debounce(this.resize, 100);
  },
  mounted() {
    this.load();
  },
  computed: {
    id() {
      // eslint-disable-next-line no-restricted-properties
      return `chart-${this.randomNumber(10)}`;
    }
  },
  methods: {
    load() {
      const div = document.getElementById(this.id);
      if (!div) return null;
      this.chart = echarts.init(div);
      this.chart.setOption(this.options);
      this.chart.on('click', (e) => this.$emit('click', e));
    },
    randomNumber(digits) {
      // eslint-disable-next-line
      return Math.floor(Math.pow(10, digits - 1) + Math.random() * (Math.pow(10, digits) - Math.pow(10, digits - 1) - 1));
    },
    resize() {
      if (!this.chart) return;
      this.chart.resize();
    }
  },
  data() {
    return {
      chart: null,
      debouncedResize: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
